import React, { useEffect } from "react"
import { useParams, useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { Spin } from "antd"
import { getWaiverSubmissionById } from "store/digital-waiver"
import { SignDocumentModal } from "pagesV2/pro/Embedded/BookingConfirmation/modal/SignDocument"
import { routes } from "router"

export default function WaiverResumePage() {
  const params = useParams()
  const { uuid, token } = params
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { data: submission, loading } = useSelector((state) => state.digitalWaiver.currentWaiverSubmission)


  useEffect(() => {
    dispatch(getWaiverSubmissionById(token))
  }, [token]) // eslint-disable-line

  if (loading || !submission) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Spin size="large" />
      </div>
    )
  }

  return (
    <SignDocumentModal
      uuid={uuid}
      waiverSubmissionId={token}
      pendingSubmission={submission?.pending_waiver_submissions || []}
      bookingWaivers={submission?.booking_waivers || []}
      open={true}
      fullScreen
      onCancel={() => navigate(routes.clientBookingPath({ uuid }))}
    />
  )
}
